/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Action_UnconfirmedInputs */



/**
* | output |
* | --- |
* | "An action from your last session could not be confirmed — check the tournament state." |
*
* @param {Tournament_Action_UnconfirmedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_action_unconfirmed = /** @type {((inputs?: Tournament_Action_UnconfirmedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Action_UnconfirmedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une action de votre dernière session n'a pas pu être confirmée — vérifiez l'état du tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una acción de su última sesión no se pudo confirmar — revise el estado del torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Uma ação da sua última sessão não pôde ser confirmada — verifique o estado do torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un'azione della tua ultima sessione non è stata confermata — controlla lo stato del torneo.")
	return /** @type {LocalizedString} */ ("An action from your last session could not be confirmed — check the tournament state.")
});